import React from 'react';
import { Icon } from '@wmgtech/legato';
import { cn } from 'utils/index';
import styles from './ToastCloseIcon.module.scss';
import { EIconTypes } from '../ToastService';

const ToastCloseIcon = () => (<Icon name={EIconTypes.close} className={cn(styles.icon, 'fa-lg')}/>);

export default ToastCloseIcon;